import React from "react";
import { Typography, Space, Card, Divider, Image, Col, Row } from "antd";
import { Icon } from "@iconify/react";
import { Fade } from "react-awesome-reveal";
import { useNavigate } from "react-router-dom";

export const FinancingCard = (props: any) => {
  const { data } = props;
  const navigate = useNavigate();
  return (
    <Card
      bodyStyle={{}}
      style={{
        width: "100%",
        borderRadius: "15px",
        height: "100%",
        background: "#F9FBFD",
        border: "1px solid #EDEEF0",
      }}
    >
      <Row>
        <Col span={24}>
          <Fade direction="up" triggerOnce cascade={true} damping={0.1}>
            <div>
              <Typography.Title level={5} style={{ marginBottom: 0, color : "#00338D" }}>
                {data.title}
              </Typography.Title>
              <div>
                <Typography.Text style={{ color: "#9A9CA5" }}>
                  By {data.agency}
                </Typography.Text>
              </div>
              <div style={{ paddingTop: 10, paddingBottom: 20 }}>
                <Row>
                  <Col span={8}>
                    <div style={{ display: "flex" }}>
                      <div>
                        <Icon
                          icon={"codicon:location"}
                          fontSize={15}
                          color="#003087"
                        />
                      </div>
                      <div style={{ paddingLeft: 10 }}>
                        <Typography.Text style={{ color: "#1E49E2" }}>
                          {data.location}
                        </Typography.Text>
                      </div>
                    </div>
                  </Col>
                  <Col span={8}>
                    <div style={{ display: "flex" }}>
                      <div>
                        <Icon
                          icon={"ic:outline-star-border"}
                          fontSize={15}
                          color="#003087"
                        />
                      </div>
                      <div style={{ paddingLeft: 10 }}>
                        <Typography.Text style={{ color: "#1E49E2" }}>
                          {data.rating}
                        </Typography.Text>
                      </div>
                    </div>
                  </Col>
                </Row>
              </div>
              <div>
                <Row>
                  <Col span={12}>
                    <img src={data.image} style={{ maxWidth: "100%" }} />
                  </Col>
                  <Col span={12}>
                    <div>
                      <Typography.Text
                        className="textSmall"
                        style={{ color: "#1E49E2" }}
                      >
                        Invest Amount
                      </Typography.Text>
                      <Typography.Title level={3} style={{ marginTop: 0 }}>
                        {data.amount}
                      </Typography.Title>
                    </div>
                  </Col>
                </Row>
              </div>
            </div>
          </Fade>
        </Col>
      </Row>
    </Card>
  );
};
